import type { ReactNode } from "react";

export interface IndexViewProps {
  /**
   * The connected members search experience (a viewport-driven map with member pins
   * and result cards), wired to InstantSearch in the container. Members search has no
   * top-bar search/filter chrome — the map viewport is the only filter — so this
   * presentational boundary simply renders the search content it is given.
   */
  children: ReactNode;
}

export function IndexView({ children }: IndexViewProps) {
  return <>{children}</>;
}
